import React, {useEffect, useState, useContext} from 'react';
import SwiperCore, {A11y, Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import CategoryService from '../../services/category.service';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
import styles from './ServiceSection.module.css';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
import Link from 'next/link';
import TNHContext from '@contexts/TNHContext';
import {safeHtml} from '@helper/sanitize-html';

export default function SlideHome() {
    const {locale} = useRouter();
    const {setSelectedDoctor} = useContext(TNHContext);
    const [productCategories, setProductCategories] = useState([]);

    useEffect(() => {
        const categoryService = new CategoryService();
        categoryService
            .getProductCategoryHome({locale})
            .then(response => {
                setProductCategories(response);
            })
            .catch(error => {
                console.error('Error fetching product categories:', error);
            });
    }, [locale]);

    const swiperConfig = {
        spaceBetween: 40,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 4.5,
                spaceBetween: 20,
            },
        },
        pagination: {
            type: 'progressbar',
        },
    };

    return (
        <>
            <section className="svc container" aria-labelledby="svc-title">
                <header className="svc__head">
                    <div className="svc__left">
                        <h2 id="svc-title" className="svc__title">
                            {getLocaleContent(locale, 'page.service.title')}{' '}
                            <span>{getLocaleContent(locale, 'page.service.sub-title')}</span>
                        </h2>
                        <p className="svc__lead">{getLocaleContent(locale, 'page.service.lead')}</p>
                    </div>
                    <Link href="/san-pham-dich-vu">
                        <a className="svc__all">
                            {getLocaleContent(locale, 'common.see-all')}{' '}
                            <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M8 5l8 7-8 7"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </a>
                    </Link>
                </header>

                <Swiper
                    {...swiperConfig}
                    className={`${styles['swiper-container']} ${styles['bleed-right']}`}
                    style={{
                        paddingBottom: '18px',
                    }}>
                    {productCategories.map((productCategory, index) => (
                        <SwiperSlide key={index}>
                            <article className="svc-card">
                                <figure className="svc-card__media">
                                    <img src={productCategory.picture_url} alt={productCategory.category_name} />
                                </figure>

                                <div className="svc-card__content">
                                    <h3 className="svc-card__title">{productCategory.category_name}</h3>

                                    <div className="svc-card__more">
                                        <div dangerouslySetInnerHTML={safeHtml(productCategory.description)}></div>
                                        <img src="/bw_image/chevron-right.svg" alt="" />
                                        <a
                                            className="cta"
                                            href="#dv-dat-lich"
                                            onClick={e => {
                                                e.preventDefault();
                                                // Clear doctor khi click từ dịch vụ
                                                console.log('[ServiceSection] Click đặt lịch từ dịch vụ, clear doctor');
                                                setSelectedDoctor({
                                                    clearDoctor: true, // Flag để BookingForm biết cần clear doctor
                                                });
                                                // Scroll xuống form
                                                const el = document.getElementById('dv-dat-lich');
                                                if (el) el.scrollIntoView({behavior: 'smooth'});
                                            }}>
                                            <img className="icon" src="/bw_image/ic_calendar.svg" alt="" />
                                            {getLocaleContent(locale, 'common.booking')}
                                        </a>
                                    </div>
                                </div>
                            </article>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
        </>
    );
}
